// Localização: frontend/src/components/Prontuario/Profissional/RH/FeriasFormModal.jsx (versão 1.0.0)
// Modal de formulário para registrar férias

import React, { useState } from 'react';
import { X } from 'lucide-react';
import { createFerias } from '../../../../api/api';

const FeriasFormModal = ({ isOpen, onClose, profissionalId, onSuccess }) => {
    const [formData, setFormData] = useState({
        data_inicio: '',
        data_fim: '',
        dias_totais: '',
        periodo_aquisitivo_inicio: '',
        periodo_aquisitivo_fim: '',
        tipo_ferias: 'integral',
        abono_pecuniario: false,
        status: 'agendada',
        observacoes: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        try {
            const dados = {
                ...formData,
                dias_totais: parseInt(formData.dias_totais)
            };

            const response = await createFerias(profissionalId, dados);
            if (response.data.success) {
                onSuccess();
            } else {
                setError(response.data.message || 'Erro ao registrar férias.');
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Erro ao registrar férias.');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
                    <h2 className="text-xl font-semibold text-gray-900">Registrar Férias</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <X className="h-6 w-6" />
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="p-6 space-y-4">
                    {error && (
                        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
                            {error}
                        </div>
                    )}

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Data de Início *
                            </label>
                            <input
                                type="date"
                                required
                                value={formData.data_inicio}
                                onChange={(e) => setFormData({ ...formData, data_inicio: e.target.value })}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Data de Fim *
                            </label>
                            <input
                                type="date"
                                required
                                value={formData.data_fim}
                                onChange={(e) => setFormData({ ...formData, data_fim: e.target.value })}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Total de Dias *
                            </label>
                            <input
                                type="number"
                                required
                                value={formData.dias_totais}
                                onChange={(e) => setFormData({ ...formData, dias_totais: e.target.value })}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                                placeholder="30"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Tipo de Férias *
                            </label>
                            <select
                                required
                                value={formData.tipo_ferias}
                                onChange={(e) => setFormData({ ...formData, tipo_ferias: e.target.value })}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                            >
                                <option value="integral">Integral</option>
                                <option value="parcial_1">Parcial 1 (10 dias)</option>
                                <option value="parcial_2">Parcial 2 (10 dias)</option>
                                <option value="parcial_3">Parcial 3 (10 dias)</option>
                            </select>
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Período Aquisitivo - Início *
                            </label>
                            <input
                                type="date"
                                required
                                value={formData.periodo_aquisitivo_inicio}
                                onChange={(e) => setFormData({ ...formData, periodo_aquisitivo_inicio: e.target.value })}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Período Aquisitivo - Fim *
                            </label>
                            <input
                                type="date"
                                required
                                value={formData.periodo_aquisitivo_fim}
                                onChange={(e) => setFormData({ ...formData, periodo_aquisitivo_fim: e.target.value })}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                            />
                        </div>
                    </div>

                    <div className="flex items-center">
                        <input
                            type="checkbox"
                            id="abono_pecuniario"
                            checked={formData.abono_pecuniario}
                            onChange={(e) => setFormData({ ...formData, abono_pecuniario: e.target.checked })}
                            className="h-4 w-4 text-teal-600 focus:ring-teal-500 border-gray-300 rounded"
                        />
                        <label htmlFor="abono_pecuniario" className="ml-2 block text-sm text-gray-700">
                            Abono Pecuniário
                        </label>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Status
                        </label>
                        <select
                            value={formData.status}
                            onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                        >
                            <option value="agendada">Agendada</option>
                            <option value="em_andamento">Em Andamento</option>
                            <option value="concluida">Concluída</option>
                            <option value="cancelada">Cancelada</option>
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Observações
                        </label>
                        <textarea
                            value={formData.observacoes}
                            onChange={(e) => setFormData({ ...formData, observacoes: e.target.value })}
                            rows={3}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                            placeholder="Observações adicionais..."
                        />
                    </div>

                    <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            disabled={loading}
                            className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors disabled:opacity-50"
                        >
                            {loading ? 'Salvando...' : 'Salvar'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default FeriasFormModal;

